//LIBRARIES
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import get from 'lodash/get';
import styled from 'styled-components';

//HELPERS
import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';
import { toDate, formatPhone } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';

//COMPONENTS
import { CotenantStatus, PortalAccessibilityFlag } from 'components/shared/StatusHelper';
import ApplicationStepper from '../ApplicationStepper';
import { BouncedEmailWarning } from 'components/shared/BouncedEmailWarning';
import UpdatePasswordDialog from 'components/shared/UpdatePasswordDialog';

//ACTIONS
import { updateTenantPassword } from 'actions/landlordTenantsActions';

const StyledIcon = styled(DeleteIcon)`
  color: ${(props) => (props.isPrimaryCotenant ? '#E5E5E5' : 'inherit')} !important;
  padding: 0;
`;

let style = {
  avatarStyle: {
    height: '120px',
    width: '120px',
    border: '0px solid #e1e1e1',
    backgroundSize: 'cover',
    float: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 0',
  },
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '15px',
  },
};

class ApplicantsDetails extends React.Component {
  state = {
    showPasswordUpdateDialog: false,
  };
  render() {
    const { application, openLeaseCreator, toggleApplicantDialog, toggleDrawer } = this.props;
    const enableEditing = featureEnabled(
      'ui.applications.enable_editing_of_applicants_after_app_completion'
    );
    const hideApplicantModification =
      !enableEditing &&
      application.yardi_status !== 'Applicant' &&
      !application.delay_unit_assignment;
    const editable = application.status !== 'payment_received' && !hideApplicantModification;
    const desiredUnitTypeName = get(application, 'desired_unit_type_name', 'None');

    return (
      <div className="row">
        <h3 style={{ margin: '15px 0px' }}> Desired Unit Type </h3>
        <p>{desiredUnitTypeName}</p>
        <h3 style={{ margin: '15px 0px' }}> Applicant Details </h3>
        {this._renderApplicants(editable)}
        <div className="row" style={{ marginBottom: '15px', textAlign: 'center' }}>
          <FlatButton
            label="View All Applicant Details"
            primary
            backgroundColor="#fbfbfb"
            hoverColor="grey"
            style={{
              color: AccentColor(),
            }}
            onClick={openLeaseCreator}
          />
        </div>
        {!hideApplicantModification && (
          <div className="row" style={{ margin: '15px 0', textAlign: 'center' }}>
            <FlatButton
              label="Add Applicant"
              primary
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{
                color: 'white',
              }}
              onClick={() => toggleApplicantDialog({})}
            />
          </div>
        )}
        <h3 style={{ margin: '20px 0 0 0' }}>Progress</h3>
        <ApplicationStepper
          getApplicationsAndClearOffset={this.props.getApplicationsAndClearOffset}
          toggleDrawer={toggleDrawer}
        />
        {hideApplicantModification &&
          !['payment_received', 'cancelled', 'application_denied'].includes(application.status) && (
            <div className="row" style={{ margin: '15px 0', textAlign: 'center' }}>
              <i className="em em-warning" style={{ marginTop: '16px' }} />
              <p style={{ marginTop: '8px', color: colors.YUHU_RED }}>
                It looks like this application has been modified on Yardi. In order to add, delete
                or modify applicant details, the status of this application cannot be "Current" in
                Yardi.
              </p>
            </div>
          )}

        <UpdatePasswordDialog
          showDialog={this.state.showPasswordUpdateDialog}
          hideDialog={this.toggleUpdatePasswordDialog}
          updatePasswordAction={this.updatePassword}
        />
      </div>
    );
  }

  _renderApplicants = (editable) => {
    const cotenants = deepDiver(this.props.application, 'cotenants');
    return cotenants.map((cotenant) => {
      const cotenantDetails = cotenant.general_details;
      style = {
        ...style,
        avatarStyle: {
          ...style.avatarStyle,
          backgroundImage: 'url(' + deepDiver(cotenantDetails, 'avatar_url') + ')',
        },
      };

      const applicant = {
        dob: toDate(cotenant.birthday),
        ...cotenant,
      };

      return (
        <React.Fragment>
          <Card style={style.transactionCard}>
            <CardText style={{ padding: '0' }}>
              <div className="row" style={{ margin: '15px 0 15px' }}>
                <div className="col-xs-12" style={{ marginTop: '0px' }}>
                  <BouncedEmailWarning
                    isBouncedEmail={cotenantDetails.bounced_email}
                    userName={cotenantDetails.full_name}
                  />
                </div>

                <div className="col-xs-9">
                  <div className="row" style={{ margin: '10px 0' }}>
                    <div className="col-xs-10" style={{ padding: 0 }}>
                      <CotenantStatus
                        style={{ padding: '5px 5px 5px' }}
                        status={cotenant.application_status}
                      />
                      <PortalAccessibilityFlag
                        style={{ padding: '5px 5px 5px' }}
                        portalAccess={cotenantDetails.can_access_portal}
                        isAgentYuhu={this.props.isAgentYuhu}
                      />
                      {cotenant.is_guarantor && <span> (Guarantor) </span>}
                    </div>
                    <div className="col-xs-2" style={{ marginTop: '-3px' }}>
                      {cotenants.length > 1 && editable && (
                        <IconButton
                          style={{
                            float: 'left',
                            padding: '0px',
                            marginRight: '25px',
                            height: '1px',
                            width: '5px',
                          }}
                          onClick={() => this.props.toggleConfirmationDialog(applicant)}
                        >
                          <StyledIcon
                            size={24}
                            isPrimaryCotenant={
                              cotenant.is_primary_applicant && this.props.yardiEnabled
                            }
                          />
                        </IconButton>
                      )}
                    </div>
                  </div>
                  <h4 style={{ marginTop: 0, fontFamily: 'Circular-Bold' }}>
                    {cotenantDetails.full_name}
                  </h4>
                  <h5 style={{ marginTop: 0, overflowWrap: 'break-word' }}>
                    {cotenantDetails.email}
                  </h5>
                  <h5 style={{ marginTop: 0 }}>{formatPhone(cotenantDetails.phone_number)}</h5>
                </div>
                <div className="col-xs-3">
                  <Paper circle={true} style={style.avatarStyle} />
                </div>
                <div className="col-xs-12" style={{ marginTop: '16px' }}>
                  {this._renderEditLink(applicant, editable)}
                  {this._renderSendPassResetLink(applicant)}
                  {this._renderSendRegistrationLink(applicant)}
                  {this._renderApplyInPerson(applicant)}
                  {this._renderAddDocument(applicant)}
                  {this._renderBypassSignature(applicant)}
                  {this._renderPasswordUpdate(applicant)}
                </div>
              </div>
            </CardText>
          </Card>
        </React.Fragment>
      );
    });
  };

  _renderEditLink = (cotenant, editable) => {
    if (!editable) {
      return (
        <Link className="link-button" to={`/companies/tenants?tenantId=${cotenant.id}`}>
          Edit
        </Link>
      );
    } else {
      return (
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleApplicantDialog(cotenant)}
        >
          Edit
        </button>
      );
    }
  };

  _renderSendPassResetLink = (cotenant) => {
    if (!cotenant.has_registered || !cotenant.email) return;
    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleInvitationOrPassResetDialog(cotenant)}
        >
          Send Password Reset Link
        </button>
      </span>
    );
  };

  _renderPasswordUpdate = (cotenant) => {
    if (!this.props.isUserAdmin) return;
    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.toggleUpdatePasswordDialog(cotenant)}
        >
          {getTranslatedString('landlordPortal.tenantUpdatePassword.updatePassword')}{' '}
        </button>
      </span>
    );
  };

  _renderSendRegistrationLink = (cotenant) => {
    if (cotenant.has_registered || !cotenant.email) return;
    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleInvitationOrPassResetDialog(cotenant)}
        >
          Send Registration Link
        </button>
      </span>
    );
  };

  _renderBypassSignature = (cotenant) => {
    if (!featureEnabled('applications.guarantor_bypass_signature')) return;
    if (!cotenant.is_guarantor) return;
    if (['denied', 'signed_lease', 'bypassed_signature'].includes(cotenant.application_status))
      return;

    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleBypassSignature(cotenant)}
        >
          Bypass Signature
        </button>
      </span>
    );
  };

  _renderApplyInPerson = (cotenant) => {
    if (cotenant.application_status !== 'pending') return;
    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleManualApplicantEntry(cotenant)}
        >
          Apply In-person
        </button>
      </span>
    );
  };

  _renderAddDocument = (cotenant) => {
    return (
      <span>
        {' '}
        |{' '}
        <button
          type="button"
          className="link-button"
          onClick={() => this.props.toggleAddDocumentDialog(cotenant)}
        >
          Add Document
        </button>
      </span>
    );
  };

  toggleUpdatePasswordDialog = (applicant) => {
    this.setState({
      showPasswordUpdateDialog: !this.state.showPasswordUpdateDialog,
      applicant,
    });
  };

  updatePassword = async (newPassword) => {
    await this.props.updateTenantPassword(this.state.applicant.id, newPassword);
    this.toggleUpdatePasswordDialog();
  };
}

export default connect(
  (store) => {
    return {
      isUserAdmin: store.userTypes.admin,
      yardiEnabled: store.userTypes.yardiEnabled,
      isAgentYuhu: store.userTypes.isYuhu,
    };
  },
  { updateTenantPassword }
)(ApplicantsDetails);
